import React from 'react';
import moment from 'moment';

import {
  DATE_TIME_FORMAT,
  STATUS_CODE,
  FILE_CODE,
} from '../utilities/constants';
import { getFileExtension } from '../utilities/fileType';
import PrintService from '../services/Prints';
import PrintUtility from '../utilities/printUtility';
import { WorkerRegistrationApplicationService } from '../services/WorkerRegistrationApplication';
import '../styles/organisms/worker-registration-application-upload-info.scss';

export const WorkerRegistrationApplicationUploadInfo = ({ fileInfo }) => {
  const getFile = async (id, fileName) => {
    const response = await WorkerRegistrationApplicationService.downloadPDFWorkerRegistration(
      id
    );
    if (!response.result) {
      return { result: response.result };
    }

    const ext = getFileExtension(fileName);
    if (ext !== 'pdf' && ext !== 'docx') {
      return null;
    }

    const contentType =
      ext === 'pdf'
        ? 'application/pdf'
        : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    const blob = PrintUtility.convertBase64ToBlob(
      response.data.entities.data,
      contentType
    );
    blob.lastModifiedDate = new Date();
    blob.name = fileName;
    return {
      result: response.result,
      blob,
      head_pdf_url: response.data.entities.pdf_urls.head_pdf_url,
      get_pdf_url: response.data.entities.pdf_urls.get_pdf_url,
    };
  };

  const downloadPDFWorkerRegistration = async (id, fileName) => {
    const ext = getFileExtension(fileName);
    const isPdf = ext === 'pdf';
    const newTab = isPdf ? window.open('/LayoutPrint', '_blank') : null;
    let needCloseTab = isPdf ? true : false;
    try {
      const { blob, head_pdf_url, get_pdf_url } = await getFile(id, fileName);
      if (blob === null) {
        return;
      }

      PrintUtility.printBlob(
        blob,
        fileName,
        isPdf ? FILE_CODE.PDF : FILE_CODE.WORD
      );

      if (!isPdf) {
        return;
      }

      const responseS3AWS = await PrintService.getHeaderReponseURL(
        head_pdf_url
      );
      if (responseS3AWS.status !== STATUS_CODE.ok) {
        return;
      }

      newTab.location.href = get_pdf_url;
      needCloseTab = false;
    } finally {
      if (needCloseTab) {
        newTab.close();
      }
    }
  };

  const { id, original_applied_filename, created_at } = fileInfo || {};

  return (
    <div className='WorkerRegistrationApplicationUploadInfo'>
      <p className='WorkerRegistrationApplicationUploadInfo__title'>
        以下の内容で申請中です。
      </p>
      <div className='WorkerRegistrationApplicationUploadInfo__body'>
        <p>
          ・申請No.： <span>{id}</span>
        </p>
        <div className='WorkerRegistrationApplicationUploadInfo__link-field'>
          <p className='WorkerRegistrationApplicationUploadInfo__link-label'>
            ・申請ファイル（作業員名簿データ）：{' '}
          </p>
          <p
            className='clickable-text WorkerRegistrationApplicationUploadInfo__text--wrap'
            onClick={() =>
              downloadPDFWorkerRegistration(id, original_applied_filename)
            }
          >
            {original_applied_filename}
          </p>
        </div>
        <p>
          ・申請日時：
          <span>
            {moment(created_at).format(DATE_TIME_FORMAT.slashDateTimeFormat)}
          </span>
        </p>
      </div>
      <p className='WorkerRegistrationApplicationUploadInfo__text--warning'>
        ※前回申請分の処理が完了するまでは、次の申請をすることができません。
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/WorkerRegistrationApplicationUploadInfo.jsx